export default "__VITE_ASSET__CrMfJOwC__"